module.exports = __webpack_public_path__ + "img/sld_spare_1_t1_dark.d46ad332.svg";